import { SalaryComponentType } from "@tymbe/legislatives/SalaryComponentType";

export const salaryComponentGroups = {
  gross: {
    name: "Hrubá mzda",
    componentTypes: [
      SalaryComponentType.Odpracovano, SalaryComponentType.OdpracovanoNoc, SalaryComponentType.OdpracovanoSvatek, SalaryComponentType.OdpracovanoSobota, SalaryComponentType.OdpracovanoNedele, SalaryComponentType.VybranaDovolena,
      SalaryComponentType.ZakladniOdmena, SalaryComponentType.PriplatekZaNoc, SalaryComponentType.PriplatekZaSvatek, SalaryComponentType.PriplatekZaSobotu, SalaryComponentType.PriplatekZaNedeli, SalaryComponentType.NahradaZaDovolenou,
      SalaryComponentType.KorekceHruba, SalaryComponentType.KorekceOdmeny,
      SalaryComponentType.HrubaOdpracovana, SalaryComponentType.HrubaOdmeny, SalaryComponentType.Hruba,
    ]
  },
  net: {
    name: "Čistá mzda",
    componentTypes: [
      SalaryComponentType.ZalohovaDanZPrijmu,
      SalaryComponentType.SrazkovaDanZPrijmu,
      SalaryComponentType.SlevaNaPoplatnika,
      SalaryComponentType.SlevaNaStudenta,
      SalaryComponentType.SlevaProZTPP,
      SalaryComponentType.SlevaProInvalidniDuchodce,
      SalaryComponentType.SlevaNaDaniCelkem,
      SalaryComponentType.SocialniPojisteni,
      SalaryComponentType.ZdravotniPojisteni,
      SalaryComponentType.MinimalniZdravotniPojisteni,
      SalaryComponentType.DoplatekNaMinimalniZdravotniPojisteni,
      SalaryComponentType.KorekceCista,
      SalaryComponentType.Cista,
    ]
  },
  payable: {
    name: "Zálohy / K vyplacení",
    componentTypes: [
      SalaryComponentType.VyplatitelneMaximum,
      SalaryComponentType.ZakladProZalohy,
      SalaryComponentType.ZadrzeneOdvodyDpc,
      SalaryComponentType.PriznaneZalohy,
      SalaryComponentType.VyplaceneZalohy,
      SalaryComponentType.KorekceKVyplate,
      SalaryComponentType.Exekuce,
      SalaryComponentType.KVyplate,
    ]
  },
  other: {
    name: "Ostatní",
    componentTypes: [
      SalaryComponentType.ZdravotniPojisteniPlaceneZamestnavatelem,
      SalaryComponentType.SocialniPojisteniPlaceneZamestnavatelem,
      SalaryComponentType.Superhruba,
      SalaryComponentType.NakladyZamestnavatele,
    ]
  },
} as const;
